const doc = [({"ko":({"adminConstantHotelLinkType":({"allLink":"모두 보기", "engineLink":"Tabichat Engine에서만 가능합니다", "noneLink":"숨겨진"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;